import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { PROMOTION_PANELS } from '../../../../const/promotion-cards.const';
import { PromotionPanelData } from '../../../../interfaces/promotion-cards.interface';

@Component({
  selector: 'app-promotion-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './promotion-card.component.html',
  styleUrl: './promotion-card.component.css',
})
export class PromotionCardComponent {
  promotionPanels: PromotionPanelData[] = PROMOTION_PANELS;
}
